<template>
  <v-row align="center" justify="center">
    <v-col>
      <div class="tcdc-ebook-card" style="cursor: pointer" @click="eventClick">
        <span class="tcdc-ebook-card-inside">
          <img :src="image" class="tcdc-ebook-image" loading="lazy" />
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: true
    },
    image: {
      type: String,
      default: ""
    }
  },
  methods: {
    eventClick () {
      this.$emit('onClick')
    }
  }
};
</script>

<style lang="scss" scoped>
/* .tcdc-article-card-border-green {
  border-bottom: 2px solid $tcdcGreen;
} */
.tcdc-ebook-card {
  overflow: hidden;
  height: 0;
  padding-top: 100%;
  background-color: $tcdcGrey2;
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: center; */
}
.tcdc-ebook-card-inside {
  position: absolute;
  width: 80%;
  height: 80%;
  /* max-width: 80%;
  max-height: 80%; */
  top: 50%;
  bottom: 0;
  left: 50%;
  right: 0;
  transform: translate(-50%, -50%);

  background-color: $tcdcGrey2;
  display: flex;
  align-items: center;
  justify-content: center;

  /* margin-left: -20px; */
  /* text-align: center; */
  /* position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto; */
  /* margin-left: auto;
  margin-right: auto; */
  /* width: 100%;
  height: 100%; */
}
.tcdc-ebook-image {
  height: 100%;
  object-fit: contain;
  /* max-width: 100%;
  max-height: 100%; */
}
</style>
